import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, distinctUntilChanged, startWith, takeUntil } from 'rxjs';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-missing-refund-filter',
  templateUrl: './missing-refund-filter.component.html',
  styleUrls: ['./missing-refund-filter.component.scss'],
  imports: [MatCheckbox, FormsModule, ReactiveFormsModule],
})
export class MissingRefundFilterComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly refund_missing = new FormControl<boolean | null>(null);

  ngOnInit(): void {
    this.payeeCasesService.refund_missing
      .pipe(
        startWith(this.payeeCasesService.refund_missing.value),
        takeUntil(this.destroy),
        distinctUntilChanged(),
      )
      .subscribe((v) =>
        this.refund_missing.patchValue(!!v, { emitEvent: false }),
      );

    this.refund_missing.valueChanges
      .pipe(takeUntil(this.destroy), distinctUntilChanged())
      .subscribe((v) =>
        this.payeeCasesService.refund_missing.next(v ? 1 : null),
      );
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
